var map = {
	"./pages_landscape_fewer.png": 58709,
	"./pages_landscape_high.png": 51140,
	"./pages_landscape_highest.png": 70694,
	"./pages_landscape_moderate.png": 3459,
	"./pages_landscape_single.png": 86472,
	"./pages_portrait_fewer.png": 24673,
	"./pages_portrait_high.png": 93568,
	"./pages_portrait_highest.png": 19338,
	"./pages_portrait_moderate.png": 13191,
	"./pages_portrait_single.png": 85644,
	"./pages_square_fewer.png": 28465,
	"./pages_square_high.png": 18832,
	"./pages_square_highest.png": 49242,
	"./pages_square_moderate.png": 39991,
	"./pages_square_single.png": 15196
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79111;